
import { defineComponent } from 'vue'
import FormGroupWrapper from './FormGroupWrapper.vue';

export default defineComponent({
    components: {FormGroupWrapper},
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        labelValue: {
            type: String,
            default: "",
            required: false
        },
        classListInput: {
            type: Array,
            default: () => [],
            required: false
        },
        labelWrapperClassList: {
            type: Array,
            default: () => [],
            required: false
        },
        labelClassList: {
            type: Array,
            default: () => [],
            required: false
        }
    },
    computed: {
        classes() {
            return this.classListInput.join(" ")
        }
    }
})
